export const footerConfig = {
  about: {
    logoText: "Empire Estates",
    description: "Empire Estates | Premium Land & Construction Services",
    mapUrl: "https://maps.app.goo.gl/coimbatore-location"
  },
  quickLinks: [
    { label: "Home", url: "/" },
    { label: "About", url: "/about-us" },
    { label: "Services", url: "/services" },
    { label: "Projects", url: "/projects" },
    { label: "Layouts", url: "/layouts" },
    { label: "Elevation", url: "/elevation" },
    { label: "Blogs", url: "/blogs" },
    { label: "Contact Us", url: "/contact-us" }
  ],
  categories: [
    { label: "Residential Plots", url: "/#sidenav_specifications" },
    { label: "Gated Communities", url: "/#sidenav_specifications" },
    { label: "Villa Development", url: "/#sidenav_specifications" },
    { label: "Investment Lands", url: "/#sidenav_specifications" }
  ],
  contact: {
    address: "No.12, Audco Nagar, 3rd main Street, Kattupakkam, Chennai, India 600056",
    phone: "88254 71748",
    email: "empireesttates@gmail.com"
  },
  socials: {
    facebook: "https://www.facebook.com/profile.php?id=61591146081912",
    instagram: "https://www.instagram.com/empireesttates",
    whatsapp: "https://wa.me/918825471748",
    youtube: "https://www.youtube.com/@empireesttates461"
  },
  supportLinks: [
    { label: "FAQ", url: "/faq" },
    { label: "Privacy Policy", url: "/privacy-policy" },
    { label: "Terms & Conditions", url: "/terms" },
    { label: "Return Policy", url: "/return-policy" }
  ],
  
  designedBy: {
    text: "Sai Techno Solutions",
    url: "https://saitechnosolutions.com/"
  }
};
